export default __webpack_public_path__ + "static/media/login.067c90a2.png";